const config = {
    URL: "http://localhost:5001/",
  
    LiveURL: "https://brainiac.whitecodetech.com/",
  
    mode: "prod",
  };
  
  export default config;
  